import React from 'react';
import { Link } from 'react-router-dom';
import './Contact.css'; // Reuse global styles

function Contact() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="navbar">
          <div className="logo">
            <img src="/logo.png" alt="logo" />
          </div>
          <div className="brand-name">Cozy Fang</div>
          <nav>
            <ul className="menu">
              <li className="home"><Link to="/">Home</Link></li>
              <li><Link to="/store">Store</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </nav>
        </div>
      </header>

      <div className="Main">
        <div className="contact-section">
          <h1>Skontaktuj się z nami</h1>
          <p>Masz pytanie, pomysł lub chcesz się przywitać? Wypełnij formularz poniżej:</p>
          <form className="contact-form">
            <div className="form-group">
                <label htmlFor="name">Imię</label>
                <input type="text" id="name" name="name" placeholder="Twoje imię" required />
            </div>
            <div className="form-group">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" name="email" placeholder="Twój email" required />
            </div>
            <div className="form-group">
                <label htmlFor="message">Wiadomość</label>
                <textarea id="message" name="message" placeholder="Napisz wiadomość..." rows="5" required></textarea>
            </div>
            <button type="submit"><span>Wyślij</span></button>
            </form>

        </div>
      </div>

      <div className="Footer">
        <img src="/logo.png" alt="Logo" />
      </div>
      <div className="Footer-bar">
        <div className="footer-left">
          COZY FANG 2025 <br />
          WSZELKIE PRAWA ZASTRZEŻONE
        </div>
        <div className="footer-icons">
          <img src="/ig.png" alt="Instagram" />
          <img src="/fb.png" alt="Facebook" />
          <img src="/yt.png" alt="YouTube" />
        </div>
        <div className="footer-right">
          <a href="/regulamin">REGULAMIN</a>
          <a href="/polityka-prywatnosci">POLITYKA PRYWATNOŚCI</a>
        </div>
      </div>
    </div>
  );
}

export default Contact;
